import SceneManager from './SceneManager'
import elementResizeDetectorMaker from 'element-resize-detector'

export default (container, data, visitordata) => {
  const canvas = createCanvas(document, container)
  const sceneManager = new SceneManager(canvas, data, visitordata)

  var erd = elementResizeDetectorMaker({
    strategy: 'scroll',
  })

  let canvasHalfWidth
  let canvasHalfHeight

  bindEventListeners()
  render()

  function createCanvas(document, container) {
    const canvas = document.createElement('canvas')
    container.appendChild(canvas)
    return canvas
  }

  function bindEventListeners() {
    container.onresize = resizeCanvas
    // window.onmousemove = mouseMove
    container.onmousedown = mouseDown
    resizeCanvas()

    erd.listenTo(container, function(element) {
      resizeCanvas()
    })
  }

  function resizeCanvas() {
    canvas.style.width = '100%'
    canvas.style.height = '100%'

    canvas.width = canvas.offsetWidth
    canvas.height = canvas.offsetHeight

    canvasHalfWidth = Math.round(canvas.offsetWidth / 2)
    canvasHalfHeight = Math.round(canvas.offsetHeight / 2)

    sceneManager.onWindowResize()
  }

  function mouseMove({ clientX, clientY }) {
    sceneManager.onMouseMove(clientX, clientY)
  }

  function mouseDown(event) {
    event.preventDefault()

    container.addEventListener('mousemove', mouseMove)
    container.addEventListener('mouseup', mouseUp)
    container.addEventListener('mouseout', mouseOut)

    sceneManager.onMouseDown(event.clientX, event.clientY)

    container.style.cursor = 'move'
  }

  function mouseUp(event) {
    container.removeEventListener('mousemove', mouseMove)
    container.removeEventListener('mouseup', mouseUp)
    container.removeEventListener('mouseout', mouseOut)
    container.style.cursor = 'auto'
  }
  function mouseOut(event) {
    container.removeEventListener('mousemove', mouseMove)
    container.removeEventListener('mouseup', mouseUp)
    container.removeEventListener('mouseout', mouseOut)
  }

  function render(time) {
    requestAnimationFrame(render)
    sceneManager.update()
  }
}



// WEBPACK FOOTER //
// ./src/components/threejs/threeEntryPoint.js